// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nX0aj","label":"styles_label__1WCku"};